import { render, staticRenderFns } from "./dashboard7.vue?vue&type=template&id=5f57ec3d&"
import script from "./dashboard7.vue?vue&type=script&lang=js&"
export * from "./dashboard7.vue?vue&type=script&lang=js&"
import style0 from "./dashboard7.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports